<template>
  <BasicLayout v-slot:default="slotProps">
    <div class="page">
      <div class="page__content">
        <CheckoutProcess />
        <dl class="contract-number">
          <dt>Auftragsnummer: </dt>
          <dd>{{ slotProps.number }}</dd>
        </dl>
        <div>
          <h2>Herzlichen Glückwünch.</h2>
          <p class="sub-title-text">Ihre Bestellung ist bestätigt.</p>
          <Contacts />
        </div>
      </div>
      <SidebarSummary v-if="slotProps.car" :car="slotProps.car" :order="slotProps.order" />
    </div>
  </BasicLayout>
</template>

<script>
import SidebarSummary from '@/components/SidebarSummary';
import BasicLayout from '../components/layout/BasicLayout';
import Contacts from '../components/Contacts';
import Status from '../components/Status';
import CheckoutProcess from '../components/CheckoutProcess';
import BankConditions from '../components/BankConditions';

export default {
  components: {
    BasicLayout,
    Contacts,
    BankConditions,
    Status,
    CheckoutProcess,
    SidebarSummary,
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 520;
    },
    isDesktop() {
      return window.innerWidth > 990;
    },
  },
};
</script>

<style lang="scss" scoped>
.order-details {
  h2 {
    padding: 0.9375rem 0.625rem 0;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }
  h3 {
    padding: 0 0.625rem;
    margin-bottom: 0.3125rem;
    font-size: 0.75rem;
  }
  &__delivery {
    margin: 0 0.625rem;
    padding: 0.625rem;
    border: 0.0625rem solid #e5e5e5;
    font-size: 0.8125rem;
    line-height: 1rem;
  }
  @include breakpoint(tablet) {
    max-width: 44.375rem;
    margin: 0 auto;
    padding: 0 1.875rem;
    background-color: #e5e5e5;
    &__content {
      background-color: $white;
    }
    h2 {
      padding: 0.9375rem 1.875rem 0;
    }
    h3 {
      padding: 0 1.875rem;
    }
    &__delivery {
      margin: 0 1.875rem 1.25rem;
    }
  }
  @include breakpoint(desktop) {
    padding: 0;
    h2 {
      font-size: 30px;
      padding-top:3rem;
    }
    h3 {
      font-size: 0.875rem;
    }
    p {
      font-size: 1rem;
      line-height: 24px;
    }
    &__delivery {
      font-size: 0.875rem;
      padding: 1rem;
    }
  }
}
</style>
